import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

export default function Iframe({ width, height, url, subtitle, title }) {
    return (
        <div className={
            classnames('cms-iframe', {
                'cms-iframe__is-responsive': !width && !height,
            })}>
            { title && <h2 className="cms-iframe--title u-reset">{ title }</h2>}
            <div className="cms-iframe--content-wrapper">
                <iframe
                    className="cms-iframe--content"
                    width={width}
                    height={height}
                    src={url} frameBorder="0"
                    allowFullScreen={true}
                />
            </div>
            {subtitle && <p className="cms-iframe--subtitle">{subtitle}</p>}
        </div>
    );
}

Iframe.propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    subtitle: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string.isRequired,
};





// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/iframe/index.js